import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Address } from '@beef/elk-common';
import { selectAddress } from "../../Mobile/store";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var mapStateToProps = function mapStateToProps(state) {
  return {
    address: selectAddress(state),
    className: cn('address'),
    isMobile: true
  };
};
export var ConvergentAddress = connect(mapStateToProps)(Address);